export default class MarginTune {
  static get isTune() {
    return true;
  }

  constructor({ api, data, config, block }) {
    this.api = api;
    this.block = block;
    this.settings = config;

    this.data = {
      margins: {
        top: data?.margins?.top ?? "auto",
        right: data?.margins?.right ?? "auto",
        bottom: data?.margins?.bottom ?? 30,
        left: data?.margins?.left ?? "auto",
      },
    };

    this._CSS = {
      wrapper: "cdx-margin-settings",
      col: "cdx-margin-column",
      row: "cdx-margin-row",
      label: "cdx-margin-label",
      input: "cdx-margin-input",

      tuneWrapper: "editor-block-tune",
      tuneTitle: "editor-block-tune-title",
      tuneText: "editor-block-tune-text",
      tuneInput: "editor-block-tune-input",
      tuneButton: "editor-block-tune-button",
      tuneContent: "editor-block-tune-content-container",
    };
  }

  wrap(blockContent) {
    this.wrapper = document.createElement("div");
    this.wrapper.style.display = "flow-root";
    this.wrapper.append(blockContent);
    this._applyMargins();
    return this.wrapper;
  }

  _applyMargins() {
    const target =
      this.wrapper.closest(".cdx-dimension-block-wrapper") ??
      this.wrapper.querySelector(".cdx-dimension-block-wrapper") ??
      this.wrapper;
    if (!target) return;

    ["top", "right", "bottom", "left"].forEach((side) => {
      const val = this.data.margins[side];
      target.style[`margin${side.charAt(0).toUpperCase() + side.slice(1)}`] =
        val === "auto" || val === "0" || val === 0 ? "auto" : `${val}px`;
    });
  }

  debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }

  render() {
    const css = this._CSS;
    const wrapper = document.createElement("div");
    const row = document.createElement("div");
    const tuneTitle = document.createElement("label");

    wrapper.classList.add(css.wrapper, css.tuneWrapper);
    tuneTitle.classList.add(css.tuneTitle);
    row.classList.add("d-flex");

    const sides = ["top", "right", "bottom", "left"];
    tuneTitle.innerHTML = "Block margins";

    sides.forEach((side) => {
      const col = document.createElement("div");
      col.classList.add(css.col);
      col.classList.add("d-flex", "flex-column", "pe-3");

      const label = document.createElement("label");
      label.classList.add(css.label);
      label.classList.add(css.tuneTitle);
      label.innerHTML = side.charAt(0).toUpperCase() + side.slice(1);

      const input = document.createElement("input");
      input.classList.add(css.input);
      input.classList.add(css.tuneInput);
      input.setAttribute("type", "number");
      input.setAttribute("min", "0");
      input.dataset.side = side;

      const current = this.data.margins[side];
      if (current && current !== "auto") {
        input.value = current;
      }

      input.addEventListener("input", (e) => {
        const val = e.target.value;
        const target =
          this.wrapper.closest(".cdx-dimension-block-wrapper") ??
          this.wrapper.querySelector(".cdx-dimension-block-wrapper") ??
          this.wrapper;

        if (val === "" || val === "0") {
          this.data.margins[side] = "auto";
        } else {
          this.data.margins[side] = val;
        }

        if (target) {
          target.style[
            `margin${side.charAt(0).toUpperCase() + side.slice(1)}`
          ] =
            this.data.margins[side] === "auto"
              ? "auto"
              : `${this.data.margins[side]}px`;
        }

        this.debounce(() => this.block.dispatchChange())();
      });

      col.appendChild(label);
      col.appendChild(input);
      row.appendChild(col);
    });
    wrapper.appendChild(tuneTitle);
    wrapper.appendChild(row);
    return wrapper;
  }

  save() {
    return this.data;
  }
}
